import { Navigate } from 'react-router-dom';
import { isLoggedIn } from 'utilities/common';

export const PrivateRoute = ({ children }) => {
  // Check if the user is logged in
  let user = isLoggedIn('userData');
  let { isAuthenticated } = user;
  // Render children if authenticated, otherwise redirect to the login page
  return isAuthenticated ? children : <Navigate to="/login" />;
};